/**
 * createProgramme.icons.ts — maps the mock content's keys to MUI icons.
 *
 * Kept separate from createProgramme.mock.ts so that file stays pure data (safe to hand to a
 * non-technical reviewer diffing copy) while this one carries the one thing that does need a
 * code change to alter: which icon a card shows.
 */
import ChildCareOutlinedIcon from "@mui/icons-material/ChildCareOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import ElderlyOutlinedIcon from "@mui/icons-material/ElderlyOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import TheaterComedyOutlinedIcon from "@mui/icons-material/TheaterComedyOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import { DeliveryFormatKey, NextActionKey, PopulationKey } from "./createProgramme.types";

export const POPULATION_ICONS: Record<PopulationKey, typeof ChildCareOutlinedIcon> = {
    child: ChildCareOutlinedIcon,
    "young-person": PersonOutlineOutlinedIcon,
    justice: GavelOutlinedIcon,
    "older-adult": ElderlyOutlinedIcon,
    dementia: PsychologyOutlinedIcon,
    "teacher-cpd": SchoolOutlinedIcon,
};

export const DELIVERY_FORMAT_ICONS: Record<DeliveryFormatKey, typeof PersonOutlineOutlinedIcon> = {
    "one-to-one": PersonOutlineOutlinedIcon,
    group: GroupsOutlinedIcon,
    classroom: SchoolOutlinedIcon,
};

export const NEXT_ACTION_ICONS: Record<NextActionKey, typeof RecordVoiceOverOutlinedIcon> = {
    assessment: RecordVoiceOverOutlinedIcon,
    "prepare-session": MenuBookOutlinedIcon,
    rehearse: TheaterComedyOutlinedIcon,
    dashboard: SpaceDashboardOutlinedIcon,
};
